const configuraciones = {
  URL_API: 'https://corall-back.sin.gamansolutions.mx/api/v1',
  ELEMENTOS_POR_PAGINA: 10,
  BIGINT_MAXLENGTH: 18,
  INT_MAXLENGTH: 9,
  URL_ARCHIVO_EJEMPLO: 'https://corall-back.sin.gamansolutions.mx/archivos/',
  NOMBRE_ARCHIVO_EJEMPLO: 'EJEMPLO_IMPORTACION_LOTES.xlsx',
  NOMBRE_ARCHIVO_EJEMPLO_BONSAI: 'EJEMPLO_IMPORTACION_LOTES_BONSAI.xlsx',
};

export default configuraciones;
